import api from '@/shared/services/all_bright_finder';
import useRole from '@/shared/composables/useRole';
import { useStore } from 'vuex';

export default function useApi() {
  const store = useStore();
  const { isSpecialist, isManager, isParent } = useRole();

  const getScopedApi = () => {
    if (!store?.state?.role) return null;

    if (isManager) return api.manager;
    if (isSpecialist) return api.organization;
    if (isParent) return api.parent;

    throw new Error(`Invalid role for scoped API: ${store.state.role}`);
  };

  const scopedApi = getScopedApi();

  return {
    api,
    scopedApi,
  };
}
